import React from 'react';
import { Box, Button, Modal, Stack, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const ErrorDialog = ({ open, handleModalClose, title, text, onClick }) => {
  const navigate = useNavigate();

  return (
    <Modal
      open={open}
      onClose={handleModalClose}
      aria-labelledby='modal-modal-title'
      aria-describedby='modal-modal-description'
      style={{
        height: 300,
        width: 500,
        position: 'absolute',
        top: '50%',
        left: '50%',
      }}
    >
      <Box
        sx={{
          transform: 'translate(-50%, -50%)',
          width: 500,
          height: 300,
          bgcolor: 'background.paper',
          borderRadius: 5,
          boxShadow: 24,
          p: 4,
          justifyContent: 'center',
        }}
      >
        <Typography
          id='modal-modal-title'
          variant='h6'
          component='h2'
          sx={{
            fontWeight: 'bold',
            color: '#000000',
            marginTop: '1rem',

            textAlign: 'center',
          }}
        >
          {title}
        </Typography>
        <Typography
          id='modal-modal-title'
          variant='h6'
          sx={{
            color: '#000000',
            marginTop: '1rem',

            textAlign: 'center',
          }}
        >
          {text}
        </Typography>
        <Stack
          direction={'row'}
          justifyContent={'space-between'}
          sx={{ marginTop: '2rem' }}
        >
          <Button
            variant='outlined'
            color='error'
            onClick={() => handleModalClose()}
          >
            Cancel
          </Button>
          <Button
            variant='outlined'
            color='primary'
            style={{}}
            onClick={() => navigate(onClick)}
          >
            OK
          </Button>
        </Stack>
      </Box>
    </Modal>
  );
};

export default ErrorDialog;
